<div class="headerDiv">
    <mat-card class="cmn-flex flex">
        <mat-card-content>
            <app-autocomplete #autoComplete (autocompleteInput)="onDeviceChanged($event)" (loadRequest)="load($event)" (selection)="selectDevice($event)"
                              [label]="'Search for a Channel'" [hint]="'Search by ID, Name, Email or Phone Number'" [objects]="autocompleteDevices" [buttonConfig]="buttonConfig" (addRequest)="newDevice()" [disabled]="invalidUser || !fullReady"
                              [options]="autocompleteDevicesFormatted" [page]="pageNum" [searchName]="'Communication Channel'" id="selectDevice"></app-autocomplete>
        </mat-card-content>
    </mat-card>
    <app-hourglass *ngIf="hourglass"></app-hourglass>
</div>
<div *ngIf="!hasSelectedDevice">
    <app-grid #grid
              (activate)="onActivate($event)"
              (pageChange)="pageCallback($event)"
              (sortChange)="sortCallback($event)"
              (filterChange)="filterChange($event)"
              [filter]="userCreatedDevicesSetting"
              [filterToggle]="showGridFilter"
              [headers]="header"
              [width]="width"
              [rows]="devices"
              [page]="page"
              [filterDesc]="'Only show channels you have created'"
              [showDeactiveIcon]="true"
              id="grid"></app-grid>
</div>
<ng-container *ngIf="error">
    <div class="adError">
        <div> {{errorText}}
            <mat-icon class="icon"></mat-icon>
        </div>
    </div>
</ng-container>
<mat-card *ngIf="resultsReady" class="cmn-flex flex spaced-top">
    <mat-card-header>
        <div class="row-flex">
            <label *ngIf="selectedDevice.id" color="primary">
                {{selectedDevice.name}} - Alerting ID: {{ selectedDevice.id }}
                <span *ngIf="!selectedDevice.active"> - (DEACTIVATED - AWAITING DELETION)</span>
            </label>
            <label *ngIf="!selectedDevice.id" color="primary">New Channel - {{selectedDevice.name}}</label>

            <span class="row-end">
                <mat-slide-toggle [(ngModel)]="selectedDevice.active" [disabled]="isDeactivated()" [hidden]="!selectedDevice.id"
                                  aria-hidden="false" aria-label="Active" color="primary" matTooltip="Set channel active status">
                </mat-slide-toggle>
                <button (click)="deleteDevice()" *ngIf="selectedDevice.id" [disabled]="!selectedDevice.active || !hasEditAccess()"
                        aria-label="Delete Icon" color="primary" id="DeleteDevice" mat-icon-button>
                    <mat-icon>delete</mat-icon>
                </button>
                <button (click)="closeDevice()" aria-label="Close Channel Button" color="primary" id="closeDeviceIcon" mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </span>
        </div>
    </mat-card-header>
    <mat-card-content>
        <hr>
        <div class="cmn-flex row align-baseline gutters">
            <mat-form-field class="flex">
                <input [(ngModel)]=selectedDevice.name
                       #nameInput="ngModel"
                       (ngModelChange)="updateName()"
                       [readonly]="isDeactivated() || !hasEditAccess()"
                       [cmnDebounce]="800"
                       autocomplete="name"
                       id="Name"
                       matInput
                       name="device_name"
                       required>
                <mat-error>Please enter a valid name</mat-error>
                <mat-placeholder>Name</mat-placeholder>
            </mat-form-field>
            <mat-form-field class="flex">
                <input #deviceNameInput="ngModel"
                       [ngModel]="selectedDevice.device_name"
                       cmnDeviceName
                       id="DeviceName" matInput name="device_devicename" readonly="true" required>
                <mat-placeholder>Device Name</mat-placeholder>
                <mat-hint>For use by mainframe paging</mat-hint>
                <mat-error *ngIf="selectedDevice.name === ''">Device Name cannot be empty</mat-error>
                <mat-error *ngIf="selectedDevice.name !== ''">Device Name is already in use</mat-error>
            </mat-form-field>
            <mat-form-field class="flex">
                <mat-label>Description</mat-label>
                <input [(ngModel)]="selectedDevice.description"
                       [readonly]="!hasEditAccess() || isDeactivated()"
                       cmnMax="255" matInput
                       name="deviceDescription"
                       type="text">
                <mat-placeholder>Description</mat-placeholder>
                <mat-hint>
                    Information about the Channel
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="flex">
                <mat-chip-list #chipList>
                    <mat-chip (click)="openIndividualPopup(owner)" (removed)="removeDeviceOwner()" *ngIf="owner && owner.id">
                        <mat-icon matTooltip="Individual">person</mat-icon>
                        {{owner.full_name}}
                        <mat-icon *ngIf="hasEditAccess()" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input [(ngModel)]="ownerSearch" #ownerInput="ngModel"
                           #ownerInputCtrl
                           (ngModelChange)="onDeviceOwnerChanged($event)"
                           [matAutocomplete]="autoIndividual"
                           [matChipInputFor]="chipList"
                           [readonly]="!hasEditAccess() || isDeactivated()"
                           [required]="ownerSelected()"
                           matInput name="device_owner">
                    <mat-autocomplete #autoIndividual="matAutocomplete" (optionSelected)="addDeviceOwner($event.option.value)">
                        <mat-option *ngFor="let option of autocompleteIndividual" [value]="option.id">
                            {{option.full_name}} <span>({{option.external_id}})</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-chip-list>
                <mat-placeholder>Owner</mat-placeholder>
                <mat-error *ngIf="!ownerSelected()">Please enter an owner.</mat-error>
                <mat-hint *ngIf="!ownerSelected()" class="error">Please enter an owner.</mat-hint>

            </mat-form-field>
        </div>
        <div class="cmn-flex row gutters">
            <mat-form-field>
                <mat-select [(ngModel)]="selectedDevice.contact_type"
                            #contactTypeInput="ngModel"
                            (ngModelChange)="contactTypeChanged()"
                            [disabled]="!hasEditAccess() || isDeactivated()"
                            id="contactTypeField"
                            matInput
                            name="contact_type"
                            required>
                    <mat-option *ngFor="let type of contactTypes" [value]="type">
                        {{type}}
                    </mat-option>
                </mat-select>
                <mat-hint>Select a Contact Type</mat-hint>
            </mat-form-field>
            <ng-container *ngIf="selectedDevice.contact_type ===  contactTypes[0]">
                <app-country-code [(value)]="countryCode"
                                  [ngClass]="{disabledDiv: isDeactivated() || !hasEditAccess()}">
                </app-country-code>
                <mat-form-field class=flex>
                    <span matPrefix> +{{ countryCode }} &nbsp;</span>
                    <input [(ngModel)]="unformatedPhone"
                           #smsInput="ngModel"
                           (ngModelChange)="updateNumber()"
                           [cmnPhoneCountryCode]="countryCode"
                           [readonly]="isDeactivated() || !hasEditAccess()"
                           cmnPhone
                           id="DevicePhone"
                           matInput
                           name="sms_address" pattern="(\d|\(|\)|-|\.)+" required>
                    <mat-placeholder>Phone</mat-placeholder>
                    <mat-error>Please enter a valid number</mat-error>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="selectedDevice.contact_type === contactTypes[1]">
                <mat-form-field class="flex">
                    <input [(ngModel)]="selectedDevice.address"
                           #emailInput="ngModel"
                           [readonly]="isDeactivated() || !hasEditAccess()"
                           cmnEmail
                           matInput name="email_address" required>
                    <mat-placeholder>Email</mat-placeholder>
                    <mat-error>A valid address is required.</mat-error>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="selectedDevice.contact_type === contactTypes[2]">
                <mat-form-field class="flex">
                            <textarea [(ngModel)]="selectedDevice.address"
                                      #webhookInput="ngModel"
                                      [readonly]="isDeactivated() || !hasEditAccess()"
                                      cmnUrl [matching]="'ssctechnologiesinc.webhook|alerting-teams.azurewebsites.net'"
                                      matInput name="webhook_address" required> </textarea>
                    <mat-placeholder>Address</mat-placeholder>
                    <mat-error>A valid webhook address is required.</mat-error>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="selectedDevice.contact_type === contactTypes[3]">
                <mat-form-field class="flex">
                    <textarea [(ngModel)]="selectedDevice.address"
                              #teamsInput="ngModel"
                              (ngModelChange)="updateTeamsLink()"
                              [readonly]="isDeactivated() || !hasEditAccess()"
                              cmnUrl
                              matInput
                              name="teams_address"
                              required> </textarea>
                    <mat-placeholder>Link</mat-placeholder>
                    <mat-error *ngIf="!teamsPrivateError">A valid MS Teams channel or group chat link is required.</mat-error>
                    <mat-error *ngIf="teamsPrivateError">Due to technical limitations, we cannot send messages to private channels (even if the service account has been added to them)</mat-error>
                </mat-form-field>
            </ng-container>
        </div>

        <div *ngIf="webhookInput" class="flex flex-row items-center">
            <mat-icon class="padded-right-lg">warning</mat-icon>
            <div class="padded">
                Please note this contact type will be deprecated in the near future. For update dates and more information please review <a href="https://devblogs.microsoft.com/microsoft365dev/retirement-of-office-365-connectors-within-microsoft-teams/">Microsoft's Notification</a>.
            </div>
        </div>

        <div *ngIf="teamsInput" class="flex flex-row items-center">
            <mat-icon class="padded-right-lg">warning</mat-icon>
            <div class="padded">
                Initial setup requires that the Alerting service account (svc_ssnc-alerting@ssctechnologiesinc.onmicrosoft.com) is a member of a public channel in a public/private team, or a group chat.<br>
                Note that a Channel cannot be used to send alerts directly to Teams users; to do this, please create a Teams contact on your <a routerLink="/user-profile">User Profile</a> instead.
            </div>
        </div>

        <mat-card *ngIf="(members !== undefined && members !== null) &&members.length > 0" class="mt20">
            <mat-card-header>
                <mat-card-title>Membership</mat-card-title>
                <mat-card-subtitle>{{selectedDevice.name}} is a member of</mat-card-subtitle>
            </mat-card-header>
            <mat-chip-list>
                <mat-chip (click)="openGroupPopup(member.id)"
                          *ngFor="let member of members">{{ member.name }}</mat-chip>
            </mat-chip-list>
        </mat-card>
    </mat-card-content>
    <mat-card-actions>
        <div class="mt20">
            <button (click)="save()" *ngIf="selectedDevice.id" [disabled]="buttonsDisabled || !hasEditAccess() || !teamsSaveAllowed"
                    class="mat-raised-button mat-primary" id="deviceSave" mat-button>
                Save
            </button>
            <button (click)="save()" *ngIf="!selectedDevice.id" [disabled]="buttonsDisabled || !teamsSaveAllowed"
                    class="mat-raised-button mat-primary" id="deviceCreate" mat-button>
                Add
            </button>
            <button (click)="teamsLinkTest()" *ngIf="teamsInput" [disabled]="buttonsDisabled"
                    class="mat-raised-button mat-primary" id="teamsTest" mat-button>
                Test
            </button>
            <button (click)="cancel()" [disabled]="buttonsDisabled" class="mat-raised-button mat-primary right"
                    id="deviceCancel" mat-button>Cancel
            </button>
        </div>
    </mat-card-actions>
</mat-card>
